import type {
  ArithmeticOperation,
  DatabankTheme,
  WorksheetMathematicsModuleType,
} from "../types"

export const allThemes = [
  "17mai",
  "christmas",
  "halloween",
  "mermaids",
  "numberchars",
  "space",
  "tools",
  "unicorn",
] as const

export const allMathematicsWorksheetModuleTypes = [
  "mathematics/neighbourNumbers",
  "mathematics/arithmetic",
  "mathematics/sudoku",
  "mathematics/guessTheHouse",
  "mathematics/numberPatterns",
  "mathematics/numberSeries",
  "mathematics/grid",
  "mathematics/sorting",
  "mathematics/pyramid",
  "mathematics/standardAlgorithm",
  "mathematics/mathCrossBox",
] as const

export const allGenericWorksheetModuleTypes = [
  "generic/wordSearch",
  "generic/crossword",
  "generic/readingTexts",
] as const

export const allWorksheetModuleTypes = [
  ...allMathematicsWorksheetModuleTypes,
  ...allGenericWorksheetModuleTypes,
] as const

export const allGradeGroups = ["1-4", "5-7"] as const

export const allArithmeticOperations = [
  "addition",
  "subtraction",
  "multiplication",
  "division",
] as const

export const allArithmeticDrawingOrders = [
  "AB=X",
  "AX=C",
  "XB=C",
  "X=AB",
  "C=AX",
  "C=XB",
] as const

export const legalGradeArithmeticOperationLookup: {
  [grade: number]: ArithmeticOperation[]
} = {
  1: ["addition"],
  2: ["addition", "subtraction"],
  3: ["addition", "subtraction"],
  4: ["addition", "subtraction", "multiplication"],
  5: ["addition", "subtraction", "multiplication", "division"],
  6: ["addition", "subtraction", "multiplication", "division"],
  7: ["addition", "subtraction", "multiplication", "division"],
}

// Based on this matrix: https://www.notion.so/Konfigurasjon-for-matematikk-d6523946da7247ef9e6b60c6c1580ca9?pvs=4#4eace096badc4d3796c760be700e4d43
export const illegalMathematicsGradeTaskTypesLookup: {
  [grade: number]: WorksheetMathematicsModuleType[]
} = {
  1: [
    "mathematics/standardAlgorithm",
    "mathematics/guessTheHouse",
    "mathematics/sudoku",
    "mathematics/numberSeries",
    "mathematics/grid",
    "mathematics/sorting",
    "mathematics/mathCrossBox",
  ],
  2: [
    "mathematics/standardAlgorithm",
    "mathematics/sudoku",
    "mathematics/numberSeries",
    "mathematics/mathCrossBox",
  ],
  3: ["mathematics/neighbourNumbers"],
  4: [
    "mathematics/neighbourNumbers",
    "mathematics/grid",
    "mathematics/sorting",
  ],
  5: [
    "mathematics/neighbourNumbers",
    "mathematics/grid",
    "mathematics/sorting",
    "mathematics/guessTheHouse",
    "mathematics/numberPatterns",
  ],
  6: [
    "mathematics/neighbourNumbers",
    "mathematics/grid",
    "mathematics/sorting",
    "mathematics/guessTheHouse",
    "mathematics/numberPatterns",
    "mathematics/numberSeries",
  ],
  7: [
    "mathematics/neighbourNumbers",
    "mathematics/grid",
    "mathematics/sorting",
    "mathematics/guessTheHouse",
    "mathematics/numberPatterns",
    "mathematics/numberSeries",
  ],
}

export const legalReadingTextThemes: DatabankTheme[] = ["bugs", "space"]
